import { SharedUtils, dt as dt$1, Theme } from 'primevue/themes';

function normalizeColor(color) {
  if (color.length === 4) {
    color = "#".concat(color[1]).concat(color[1]).concat(color[2]).concat(color[2]).concat(color[3]).concat(color[3]);
  }
  return color;
}
function hexToRgb(hex) {
  var bigint = parseInt(hex.substring(1), 16);
  var r = bigint >> 16 & 255;
  var g = bigint >> 8 & 255;
  var b = bigint & 255;
  return {
    r: r,
    g: g,
    b: b
  };
}
function rgbToHex(r, g, b) {
  return "#".concat(r.toString(16).padStart(2, '0')).concat(g.toString(16).padStart(2, '0')).concat(b.toString(16).padStart(2, '0'));
}
var mix = (function (color1, color2, weight) {
  color1 = normalizeColor(color1);
  color2 = normalizeColor(color2);
  var p = weight / 100;
  var w = p * 2 - 1;
  var w1 = (w + 1) / 2.0;
  var w2 = 1 - w1;
  var rgb1 = hexToRgb(color1);
  var rgb2 = hexToRgb(color2);
  var r = Math.round(rgb1.r * w1 + rgb2.r * w2);
  var g = Math.round(rgb1.g * w1 + rgb2.g * w2);
  var b = Math.round(rgb1.b * w1 + rgb2.b * w2);
  return rgbToHex(r, g, b);
});

var shade = (function (color, percent) {
  return mix('#000000', color, percent);
});

var tint = (function (color, percent) {
  return mix('#ffffff', color, percent);
});

var scales = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];
var palette = (function (color) {
  if (/{([^}]*)}/g.test(color)) {
    var token = color.replace(/{|}/g, '');
    return scales.reduce(function (acc, scale) {
      return acc[scale] = "{".concat(token, ".").concat(scale, "}"), acc;
    }, {});
  }
  return typeof color === 'string' ? scales.reduce(function (acc, scale, i) {
    return acc[scale] = i <= 5 ? tint(color, (5 - i) * 19) : shade(color, (i - 5) * 15), acc;
  }, {}) : color;
});

var css = function css(style) {
  return SharedUtils.object.getItemValue(style, {
    dt: dt$1
  });
};

var $dt = function $dt(tokenPath) {
  var _variable$match;
  var theme = Theme.getTheme();
  var variable = dtwt(theme, tokenPath, undefined, 'variable');
  var name = (_variable$match = variable.match(/--[\w-]+/g)) === null || _variable$match === void 0 ? void 0 : _variable$match[0];
  var value = dtwt(theme, tokenPath, undefined, 'value');
  return {
    name: name,
    variable: variable,
    value: value
  };
};
var dt = function dt() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return dtwt.apply(void 0, [Theme.getTheme()].concat(args));
};
var dtwt = function dtwt() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tokenPath = arguments.length > 1 ? arguments[1] : undefined;
  var fallback = arguments.length > 2 ? arguments[2] : undefined;
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'variable';
  if (tokenPath) {
    var _ref = Theme.defaults || {},
      VARIABLE = _ref.variable,
      OPTIONS = _ref.options;
    var _ref2 = (theme === null || theme === void 0 ? void 0 : theme.options) || OPTIONS || {},
      prefix = _ref2.prefix,
      transform = _ref2.transform;
    var regex = /{([^}]*)}/g;
    var token = SharedUtils.object.test(regex, tokenPath) ? tokenPath : "{".concat(tokenPath, "}");
    var isStrictTransform = type === 'value' || transform === 'strict'; // @todo - TRANSFORM: strict | lenient(default)

    return isStrictTransform ? Theme.getTokenValue(tokenPath) : SharedUtils.object.getVariableValue(token, undefined, prefix, [VARIABLE.excludedKeyRegex], fallback);
  }
  return '';
};

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $t = function $t() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _preset = theme.preset,
    _options = theme.options;
  return {
    preset: function preset(value) {
      _preset = _preset ? SharedUtils.object.mergeKeys(_preset, value) : value;
      return this;
    },
    options: function options(value) {
      _options = _options ? _objectSpread(_objectSpread({}, _options), value) : value;
      return this;
    },
    // features
    primaryPalette: function primaryPalette(primary) {
      var _ref = _preset || {},
        semantic = _ref.semantic;
      _preset = _objectSpread(_objectSpread({}, _preset), {}, {
        semantic: _objectSpread(_objectSpread({}, semantic), {}, {
          primary: primary
        })
      });
      return this;
    },
    surfacePalette: function surfacePalette(surface) {
      var _semantic$colorScheme, _semantic$colorScheme2;
      var _ref2 = _preset || {},
        semantic = _ref2.semantic;
      var lightSurface = surface !== null && surface !== void 0 && surface.hasOwnProperty('light') ? surface === null || surface === void 0 ? void 0 : surface.light : surface;
      var darkSurface = surface !== null && surface !== void 0 && surface.hasOwnProperty('dark') ? surface === null || surface === void 0 ? void 0 : surface.dark : surface;
      var newColorScheme = {
        colorScheme: {
          light: _objectSpread(_objectSpread({}, semantic === null || semantic === void 0 || (_semantic$colorScheme = semantic.colorScheme) === null || _semantic$colorScheme === void 0 ? void 0 : _semantic$colorScheme.light), !!lightSurface && {
            surface: lightSurface
          }),
          dark: _objectSpread(_objectSpread({}, semantic === null || semantic === void 0 || (_semantic$colorScheme2 = semantic.colorScheme) === null || _semantic$colorScheme2 === void 0 ? void 0 : _semantic$colorScheme2.dark), !!darkSurface && {
            surface: darkSurface
          })
        }
      };
      _preset = _objectSpread(_objectSpread({}, _preset), {}, {
        semantic: _objectSpread(_objectSpread({}, semantic), newColorScheme)
      });
      return this;
    },
    // actions
    define: function define() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$useDefaultPrese = _ref3.useDefaultPreset,
        useDefaultPreset = _ref3$useDefaultPrese === void 0 ? false : _ref3$useDefaultPrese,
        _ref3$useDefaultOptio = _ref3.useDefaultOptions,
        useDefaultOptions = _ref3$useDefaultOptio === void 0 ? false : _ref3$useDefaultOptio;
      return {
        preset: useDefaultPreset ? Theme.getPreset() : _preset,
        options: useDefaultOptions ? Theme.getOptions() : _options
      };
    },
    update: function update() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$mergePresets = _ref4.mergePresets,
        mergePresets = _ref4$mergePresets === void 0 ? true : _ref4$mergePresets,
        _ref4$mergeOptions = _ref4.mergeOptions,
        mergeOptions = _ref4$mergeOptions === void 0 ? true : _ref4$mergeOptions;
      var newTheme = {
        preset: mergePresets ? SharedUtils.object.mergeKeys(Theme.getPreset(), _preset) : _preset,
        options: mergeOptions ? _objectSpread(_objectSpread({}, Theme.getOptions()), _options) : _options
      };
      Theme.setTheme(newTheme);
      return newTheme;
    },
    use: function use(options) {
      var newTheme = this.define(options);
      Theme.setTheme(newTheme);
      return newTheme;
    }
  };
};

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function toVariables (theme) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var VARIABLE = Theme.defaults.variable;
  var _options$prefix = options.prefix,
    prefix = _options$prefix === void 0 ? VARIABLE.prefix : _options$prefix,
    _options$selector = options.selector,
    selector = _options$selector === void 0 ? VARIABLE.selector : _options$selector,
    _options$excludedKeyR = options.excludedKeyRegex,
    excludedKeyRegex = _options$excludedKeyR === void 0 ? VARIABLE.excludedKeyRegex : _options$excludedKeyR;
  var _toVariables = function _toVariables(_theme) {
    var _prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.entries(_theme).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      var px = SharedUtils.object.test(excludedKeyRegex, key) ? SharedUtils.object.toNormalizeVariable(_prefix) : SharedUtils.object.toNormalizeVariable(_prefix, SharedUtils.object.toKebabCase(key));
      var v = SharedUtils.object.toValue(value);
      if (SharedUtils.object.isObject(v)) {
        var _toVariables2 = _toVariables(v, px),
          _variables = _toVariables2.variables,
          _tokens = _toVariables2.tokens;
        SharedUtils.object.merge(acc['tokens'], _tokens);
        SharedUtils.object.merge(acc['variables'], _variables);
      } else {
        acc['tokens'].push((prefix ? px.replace("".concat(prefix, "-"), '') : px).replaceAll('-', '.'));
        SharedUtils.object.setProperty(acc['variables'], SharedUtils.object.getVariableName(px), SharedUtils.object.getVariableValue(v, px, prefix, [excludedKeyRegex]));
      }
      return acc;
    }, {
      variables: [],
      tokens: []
    });
  };
  var _toVariables3 = _toVariables(theme, prefix),
    variables = _toVariables3.variables,
    tokens = _toVariables3.tokens;
  return {
    value: variables,
    tokens: tokens,
    declarations: variables.join(''),
    css: SharedUtils.object.getRule(selector, variables.join(''))
  };
}

export { $dt, $t, css, dt, dtwt, mix, palette, shade, tint, toVariables };
//# sourceMappingURL=index.mjs.map
